import React, { useEffect } from "react";
import { useAddVideoIntro } from "../../../../../api/inquiries/video/use-video";
import Button from "../../../../../components/ui/Button/Button";
import Loading from "../../../../../components/ui/Loading/Loading";
import Modal from "../../../../../components/ui/Modal/Modal";
import FieldBox from "../../../../../utils/Form/ui/FieldBox";

const IntroModal = () => {
  const [url, setUrl] = React.useState("");
  const videoId = url?.includes("watch")
    ? url?.split("watch?v=")[1]
    : url?.includes("youtu.be")
    ? url?.split("youtu.be/")[1]
    : "";
  const [savedIntro, setSavedIntro] = React.useState("");
  const [isSaved, setIsSaved] = React.useState(false);
  const [triggerClose, setTriggerClose] = React.useState(false);
  const { mutate: addVideoIntro, isLoading } = useAddVideoIntro();
  const [isUploadingIntro, setIsUploadingIntro] = React.useState(false);

  React.useEffect(() => {
    if (triggerClose === true) {
      setTriggerClose(false);
    }
  }, [triggerClose]);

  const onChangeUrl = (e) => {
    setUrl(e.target.value);
  };

  const onSaveIntro = () => {
    setSavedIntro(url);
    setIsSaved(true);
  };

  const onClose = () => {
    setUrl("");
    setSavedIntro("");
    setIsSaved(false);
    setTriggerClose(true);
  };

  const handleSubmit = async () => {
    await addVideoIntro({
      url: savedIntro,
    });
    setTriggerClose(true);
  };

  useEffect(() => {
    if (isLoading) {
      setIsUploadingIntro(true);
    } else {
      setIsUploadingIntro(false);
    }
  }, [isLoading]);

  return (
    <>
      <Modal
        triggerClose={triggerClose}
        hasCancel={false}
        hasSubmit={false}
        maxWidth="max-w-[36rem] px-[2rem]"
        title="제품소개 영상 변경"
        onClose={onClose}
        description={
          <>
            <FieldBox splitted isLast label="제품소개 영상 변경">
              <input
                type="text"
                className={`border border-[#cccccc] flex-none h-9 w-full py-0.5 px-2 outline-none rounded-[4px] ${
                  isSaved ? "bg-[#ededed] text-[#999999]" : ""
                }`}
                value={url}
                onChange={onChangeUrl}
                disabled={isSaved}
              />
              <div className="flex justify-end items-center gap-1 my-2">
                <Button
                  onClick={onSaveIntro}
                  paddingButton="p-1"
                  width="w-24"
                  borderColor="border border-[#cccccc]"
                  text="수정하기"
                />
                <Modal
                  hasCancel={false}
                  hasSubmit={false}
                  hasClose={true}
                  title="영상 미리보기"
                  maxWidth="max-w-[45rem]"
                  description={
                    <div className="flex justify-center">
                      <iframe
                        title="intro_video"
                        width="696"
                        height="380"
                        src={`https://www.youtube.com/embed/${videoId}`}
                      ></iframe>
                    </div>
                  }
                  padding="p-5"
                >
                  <Button
                    paddingButton="p-1"
                    width="w-24"
                    isDisabled={!isSaved}
                    margin="mr-0"
                    primary
                    text="영상 미리보기"
                  />
                </Modal>
              </div>
            </FieldBox>
            <div className="flex justify-center mt-4 mb-2">
              <Modal
                description="입력을 취소하시겠습니까? 입력한 정보는 저장되지 않습니다."
                onSubmit={onClose}
              >
                <Button width="w-20" text="입력취소" />
              </Modal>
              <Modal
                description={
                  <span>
                    입력한 정보로 등록하시겠습니까?
                    <br />
                    등록완료를 해야만 최종적으로 제품소개 영상이 업로드 됩니다.
                  </span>
                }
                onSubmit={handleSubmit}
              >
                <Button
                  width="w-20"
                  margin="m-0"
                  primary
                  text="등록완료"
                  isDisabled={savedIntro === ""}
                />
              </Modal>
            </div>
          </>
        }
      >
        <Button text="제품소개 영상 변경" />
      </Modal>
      {isUploadingIntro && (
        <div className="w-full h-full fixed m-auto bg-white z-[99]">
          <Loading />
        </div>
      )}
    </>
  );
};

export default IntroModal;
